/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Edible = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Edible"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#F90"
        d="M11.946 2c4.756 0 8.612 2.035 8.612 4.546l-.001.01q.116.349.168.726l1.133 8.366a3.97 3.97 0 0 1-.428 2.404c-.614 2.229-4.624 3.95-9.484 3.95S3.073 20.28 2.461 18.05a3.97 3.97 0 0 1-.425-2.402L3.17 7.282q.051-.376.166-.723v-.013C3.335 4.036 7.191 2 11.946 2"
        className="Main"
      />
      <ellipse
        cx={11.947}
        cy={4.728}
        fill="#FFEBCC"
        className="Main"
        rx={2.728}
        ry={0.909}
      />
      <path
        fill="#000"
        fillOpacity={0.2}
        d="M11.946 12.91c4.52 0 8.183 1.63 8.184 3.638s-3.665 3.637-8.184 3.637c-4.52 0-8.183-1.629-8.183-3.637.001-2.009 3.664-3.637 8.183-3.637m4.877-6.942a.819.819 0 0 1 1.157 1.157c-.598.598-2.79 2.058-6.034 2.058s-5.435-1.46-6.033-2.058A.818.818 0 1 1 7.07 5.968c.31.31 2.094 1.578 4.876 1.579s4.566-1.269 4.877-1.58"
        className="Details"
      />
    </g>
  </svg>
);

export const EdibleIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'edible-icon'}
      icon={Edible}
      {...props}
      size={size}
    />
  );
};
